import React, { useRef } from "react";
import * as Constants from "../constants";
interface LoginProps {
  logout?: boolean;
  setLoggedIn: any;
}

const Login = (props: LoginProps) => {
  const [ferror, setError] = React.useState(false);
  let logout = props.logout;
  const form = useRef() as React.MutableRefObject<HTMLFormElement>;

  function doLogout() {
    if (logout) {
      return Constants.api.get("/Account/Logout").then((response) => {
        localStorage.setItem("loggedin", JSON.stringify(false));
        window.location.href = "/login";
      });
    }
  }

  React.useEffect(() => {
    doLogout();
  });

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const data: any = new FormData(form.current);
    Constants.api.post("/Account/Login/", data).then(
      (response: { data: { succeeded: boolean } }) => {
        if (response?.data?.succeeded === true) {
          setError(false);
          props.setLoggedIn(true);
          Constants.ga4react.initialize().then((ga4) => {
            ga4.event("Logged in","Loggedin","Loggedin")
          });
          setTimeout(function () {
            window.location.href = "/street";
          }, 500);
        } else {
          setError(true);
        }
      },
      (error) => {
        setError(true);
      }
    );
  };

  return (
    <div className="login-frame">
      <div className="login">
        <h1>Inloggen Milieustraten Dashboard</h1>
        <form
          method={"POST"}
          className="login"
          ref={form}
          onSubmit={handleSubmit}
        >
          {ferror && (
            <span className="login-error">
              Gebruikersnaam en/of wachtwoord is onjuist
            </span>
          )}
          <label>
            <p>Gebruikersnaam</p>
            <input name="Username" type="text" />
          </label>
          <label>
            <p>Wachtwoord</p>
            <input name="Password" type="password" />
          </label>
          <button type="submit">Inloggen</button>
        </form>
      </div>
    </div>
  );
};
export default Login;
